module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAV1BMVEUAAAAzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzNJt775AAAAHHRSTlMA3LDlyMGM16hb+Om+disHh2YV7NDPmklBOyIQVTGniAAAAJNJREFUOMvlz7sSgjAURdEkN5IE8gB86/n/77RxMjpg5hSMDbtezVZ7r9PykQs/ocZXtgFdV3NNaFTtsB3MpisUPAMjBR3gKZj06fGG2SZuxsNx0EA3YJluHIzoJwpqwFPQ98OVgirPioA1As6Fg5ej3Le9tugTBZ9joK//DYMZILYmEKMxmLCAgtVkAaOsFtWuewFQbRDmw8u89QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-top7.png
// module id = uUaY
// module chunks = 21